import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchFiles(orderId) {
  return dispatch => {
    myGet(dispatch, servAddr + 'file', {
      params: {order_id: orderId}
    }).then((response) => {
      dispatch({type: "FETCH_FILES", payload: {files:response.data.files,order_id:orderId}});
      dispatch({type: "FETCH_FILETYPES", payload: response.data.filetypes});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function editFile(file, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.file_post === 1 ? 'file' :
    'file_assigned';
  return dispatch => {
    const data = new FormData();
    for (let key in file) {
      if (file.hasOwnProperty(key)) {
        data.append(key, file[key]);
      }
    }
    myPost(dispatch, servAddr + model, data).then((response) => {
      cb();
      if (file.file_id) {
        dispatch({type: "EDIT_FILE", payload: file});
      }
      else {
        dispatch({
          type: "CREATE_FILE",
          payload: {
            ...file,
            file_id:response.data.id
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/fileActions.js